









































import * as battle from '@/services/battle';

import { Component, Vue } from 'vue-property-decorator';
import Mob from '@/models/Mob';
import mobs, { IMobAttackType } from '@/data/mobs';

import AppBtn from '@/components/AppBtn.vue';
import AttackResult from '@/components/AttackResult.vue';
import AppBtnGroup from '@/components/AppBtnGroup.vue';
import MobHealthBar from '@/components/MobHealthBar.vue';

@Component({
  components: {
    MobHealthBar,
    AttackResult,
    AppBtn,
    AppBtnGroup
  }
})
export default class FightView extends Vue {
  attackResult: battle.IFightResult | null = null;
  mobHealth: number = 0;
  trashemonHealth: number = 0;

  created() {
    this.mobHealth = this.mob.health;
    this.trashemonHealth = this.trashemon.health;
  }

  fight(attack: IMobAttackType) {
    this.attackResult = battle.fight(this.trashemon, this.mob, attack);
    this.mobHealth = this.mobHealth - this.attackResult!.damage;
    if (this.mobHealth <= 0) {
      this.$router.push({ name: 'Victory' })
    }
  }

  get mob(): Mob {
    return this.$store.getters['game/currentMob'];
  }

  get mobLevel(): number {
    return Mob.xpToLevel(this.mob.xp);
  }

  get trashemon(): Mob {
    return this.$store.getters['game/currentTrashemon'];
  }

  get trashemonAttacks(): IMobAttackType[] {
    const mobType = mobs.get(this.trashemon.type);
    return mobType!.attacks;
  }

  get trashemonLevel(): number {
    return Mob.xpToLevel(this.trashemon.xp);
  }
}
